import { MetricidService } from '@src/api/metricIdConst';
import { ROUTES_PATHS } from '@src/constants/routes';

// API Endpoints
export const CASE_SUBMISSION_DETAILS_ENDPOINT = 'case-submission-details';
export const SUBMISSION_DETAILS_ENDPOINT = 'submissiondetails';
export const TURNAROUND_TIME_ENDPOINT = 'tat';
export const CASE_SUBMISSION_BY_CHANNEL_ENDPOINT = 'case-submission-by-channel';

// Helper to build normal or bulk endpoint
export function getPriorAuthEndpoint(endpoint: string, isBulk: boolean = false): string {
  return isBulk ? `prior-auth-bulk-process-jobs/${endpoint}` : `prior-authorizations/${endpoint}/`;
}

export const CASE_SUBMISSION_DETAILS_CARD_TITLE = 'Case Submission Details';
export const PROCEDURE_CODES_LINK = ROUTES_PATHS.PriorAuth.PACptCodes;
export const NOT_APPROVED_DETAILS_LINK = ROUTES_PATHS.PriorAuth.PANotApproved;
export const TURNAROUND_TIME_CARD_TITLE = 'Prior Auth Turnaround Time';
export const INSIGHT_CARD_TITLE = 'Prior Authorization Savings Opportunity';
export const CASE_SUBMISSION_CHANNELS_CARD_TITLE = 'Case Submission Channels';

// Knowledge Center Configuration
export const CASE_SUBMISSION_METRIC_DATA = {
  title: CASE_SUBMISSION_DETAILS_CARD_TITLE,
  metricId: MetricidService.MetricIDs.PriorAuthorizationSubmissionDetails,
  titleId: 206,
};

export const INSIGHT_CARD_METRIC_DATA = {
  title: INSIGHT_CARD_TITLE,
  metricId: MetricidService.MetricIDs.PriorAuthorizationSavingsOpportunity,
  titleId: 220,
};

export const CASE_SUBMISSION_CHANNELS_METRIC_DATA = {
  title: CASE_SUBMISSION_CHANNELS_CARD_TITLE,
  metricId: MetricidService.MetricIDs.CaseSubmissionChannels,
  titleId: 271,
};

export const CASE_SUBMISSIONS_OVER_TIME_METRIC_DATA = {
  title: 'Case Submissions Over Time',
  metricId: MetricidService.MetricIDs.CaseSubmissionsOverTime,
  titleId: 207,
};

export const TURNAROUND_TIME_CARD_METRIC_DATA = {
  title: 'PA TAT',
  metricId: MetricidService.MetricIDs.PriorAuthTurnaroundTime,
  titleId: 208,
};
export const caseSubmissionDetailsBulk = '/prior-auth-bulk-process-jobs/submissiondetails';
export interface FilterOption {
  value: string;
  Name: string;
  id: number;
  disable?: boolean;
  default?: boolean;
}
export const TIME_PERIOD_OPTIONS: FilterOption[] = [
  { value: 'Last30Days', Name: 'Last 30 Days', id: 1 },
  { value: 'Last3Months', Name: 'Last 3 Months', id: 2 },
  { value: 'Last6Months', Name: 'Last 6 Months', id: 3 },
  { value: 'Last12Months', Name: 'Last 12 Months', id: 4 },
  { value: 'YTD', Name: 'Year to Date', id: 5 },
  {
    value: (new Date().getFullYear() - 1).toString(),
    Name: (new Date().getFullYear() - 1).toString(),
    id: 6,
  },
  {
    value: (new Date().getFullYear() - 2).toString(),
    Name: (new Date().getFullYear() - 2).toString(),
    id: 7,
  },
];

export const MARKET_URL = '/claim-search/topfilter';
export const TAX_STATE_REGION_URL = '/standard-search/topfilter';
export const NPI_FLOW = 'NPI';
export const TIN_FLOW = 'TIN';
export const REQUESTED_JOURNEY = 'priorAuthFilter';
export const STATE_TEXT = 'STATE';
export const MARKET_TEXT = 'MARKET';
export const REGION_STATE = 'REGION_STATE';
export const NPS_DRIVER_FILTER = 'npsDriverFilter';
export const MARKET_NAME = 'MARKETNAME';
export const REGION_STATE_INITIAL = 'REGION_STATE_INITIAL';
export const INITIAL = 'INITIAL';
export const STATE_CHANGE = 'STATE_CHANGE';
export const REGION_CHANGE = 'REGION_CHANGE';
export const NPI_FLOW_CHANGE = 'NPI_FLOW_CHANGE';
export const NPI_URL = '/prior-authorizations/topfilter/';
export const MULTI_TIN = 'MULTI_TIN';
export const PROVIDER_SETTING_OPTIONS: FilterOption[] = [
  { value: 'All', Name: 'All', id: 1 },
  { value: 'AT', Name: 'Attending Physician', id: 2 },
  { value: 'AD', Name: 'Admitting Services', id: 3 },
  { value: 'FA', Name: 'Facility', id: 4 },
  { value: 'PC', Name: 'Primary Care Provider', id: 5 },
  { value: 'PM', Name: 'Provider Medical Group', id: 6 },
  { value: 'RF', Name: 'Requesting Provider', id: 7 },
  { value: 'SJ', Name: 'Servicing', id: 8 },
];

export const LOB_NAME_OPTIONS: FilterOption[] = [
  { value: 'All', Name: 'All Lines of Business', id: 1 },
  { value: 'EI', Name: 'Commercial', id: 2 },
  { value: 'MR', Name: 'Medicare', id: 3 },
  { value: 'CS', Name: 'Medicaid', id: 4 },
  { value: 'EXC', Name: 'Individual Exchange', id: 5 },
];
